import React from 'react';
import { Page } from '../Page';
export function PageIntro() {
  return <Page pageNumber={1} variant="light" data-id="element-1267">
      <div className="flex h-full -mx-12 -mt-10 -mb-10" data-id="element-1268">
        {/* Left: Large author photo */}
        <div className="w-[45%] relative overflow-hidden bg-[#e8e8e8]" data-id="element-1269">
          <img src="https://cdn.magicpatterns.com/uploads/7FbupA4igV3MjRPDFBJYCQ/5.png" alt="Jack Achenbach MS, RDN, CPT" className="w-full h-full object-cover object-center grayscale" data-id="element-1270" />
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/50 to-transparent p-6" data-id="element-1271">
            <p className="text-xs text-white/90 font-bold tracking-wide" data-id="element-1272">
              Jack Achenbach
            </p>
            <p className="text-[10px] text-white/70" data-id="element-1273">MS, RDN, CPT</p>
          </div>
        </div>

        {/* Right: Content */}
        <div className="w-[55%] flex flex-col justify-center px-10 py-12" data-id="element-1274">
          <div className="mb-8" data-id="element-1275">
            <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-1276">
              Introduction
            </h1>
            <div className="flex items-center gap-3 mb-6" data-id="element-1277">
              <div className="w-16 h-0.5 bg-tealslate" data-id="element-1278" />
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="text-tealslate" data-id="element-1279">
                <path d="M2 2L8 8L2 14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-1280" />
                <path d="M8 2L14 8L8 14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-1281" />
              </svg>
            </div>
          </div>

          <div className="space-y-4 mb-8" data-id="element-1282">
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1283">
              So you've started (or are about to start) GLP-1 medication for
              weight loss. Welcome to the club! You've already taken a big step,
              and this guide is here to make sure you get the most out of it.
            </p>
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1284">
              Here's the truth: GLP-1 medications are incredibly effective at
              helping you lose weight. But the medication alone isn't the full
              picture. What you eat, how you move, and the habits you build
              alongside your medication will determine not just how much weight
              you lose, but how you feel, how you look, and whether you keep the
              weight off long term.
            </p>
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1285">
              Most people on GLP-1s are told to "eat less and move more." That's
              not wrong, but it's not enough. Without the right guidance, people
              lose muscle along with fat, develop nutrient deficiencies, and
              struggle when it's time to reduce or stop their medication.
            </p>
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-1286">
              Inside, you'll find a framework built around your body and what it
              needs to function everyday. No complicated meal plans. No
              unnecessary complexity. Just the essentials that actually matter
              for your health and your results.
            </p>
          </div>

          <div className="mt-auto border-l-4 border-tealslate pl-6 py-3" data-id="element-1287">
            <p className="text-base font-serif italic text-[#1F1F1F] leading-relaxed mb-1" data-id="element-1288">
              "Structure provides the foundation for success."
            </p>
            <p className="text-xs font-serif text-tealslate" data-id="element-1289">
              That's what this guide is for. Let's get started.
            </p>
          </div>
        </div>
      </div>
    </Page>;
}